import { importProvidersFrom } from '@angular/core';
import { Route } from '@angular/router';
import { HowItWorksComponent } from './how-it-works/how-it-works.component';
import { SchoolsComponent } from './schools/schools.component';
import { FaqComponent } from './faq/faq.component';
import { environment } from '@awo-care/shared-auth';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';

export const PAGES_ROUTES: Route[] = [
  {
    path: 'info',
    component: HowItWorksComponent,
    data: {
      // Eigene Seite: Titel H1, Schritte H2. Ohne den Eintrag setzt das
      // Input-Binding des Routers headingLevel auf undefined — die Schritte
      // trugen dann aria-level="NaN" und NVDA las sie als Ebene 1 (#1209).
      headingLevel: 1,
      title: $localize`:@@seo.info.title:So funktioniert die Anmeldung`,
      description: $localize`:@@seo.info.description:Schritt für Schritt zur Schülerbetreuung: Konto anlegen, Kind anmelden, Betreuungsmodule wählen und Vertrag abschliessen.`,
    },
  },
  {
    path: 'contact',
    loadComponent: () =>
      import('./contact/contact.component').then(
        (m) => m.ContactComponent
      ),
    providers: [
      importProvidersFrom(RecaptchaV3Module),
      {
        provide: RECAPTCHA_V3_SITE_KEY,
        useValue: environment.recaptchaSiteKey,
      },
    ],
    data: {
      title: $localize`:@@seo.contact.title:Kontakt`,
      description: $localize`:@@seo.contact.description:Fragen zur Betreuung, Anmeldung oder zum Vertrag? Nehmen Sie über das Kontaktformular Verbindung zum AWO-Care-Team auf.`,
    },
  },
  {
    path: 'schools',
    component: SchoolsComponent,
    data: {
      title: $localize`:@@seo.schools.title:Teilnehmende Schulen`,
      description: $localize`:@@seo.schools.description:Übersicht aller Schulen, an denen die AWO die Betreuung anbietet — nach Ort durchsuchbar.`,
    },
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: {
      title: $localize`:@@seo.faq.title:Häufige Fragen`,
      description: $localize`:@@seo.faq.description:Antworten auf häufige Fragen zu Anmeldung, Betreuungsmodulen, Ferienbetreuung, Kosten und Kündigung.`,
    },
  },
];
